import { useLocation, useNavigate } from 'react-router-dom';
import { useRole } from '../App';
import { useAuth } from '../auth/AuthProvider';
import { LoginIcon, LogoutIcon } from './Icons';

export function TopBar() {
  const { role, setRole } = useRole();
  const { isStaff, email, signIn, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Inside the hub, the hub is the product — wearing COMM-PASS's name there makes
  // every tool look like a COMM-PASS feature rather than a portal in its own right.
  const inHub = location.pathname.startsWith('/hub');

  return (
    <>
      <div className="topbar">
        <div className="topbar-inner">
          <div className="brand" onClick={() => navigate(inHub ? '/hub' : '/')} role="button" tabIndex={0}>
            <img className="brand-logo" src="/logo.png" alt="Agents Alliance Services" />
            <div className="brand-div" />
            <div>
              <div className="brand-name">{inHub ? 'Commercial Hub' : 'COMM-PASS'}</div>
              <div className="brand-sub">{inHub ? 'Agents Alliance' : 'Submission Portal'}</div>
            </div>
          </div>
          <div className="topbar-spacer" />

          {/* A way back to the hub from any portal. Shown to signed-in users only:
              agents who use COMM-PASS on its own keep seeing exactly what they
              always have, until the hub is deliberately opened up to them. */}
          {!inHub && isStaff && (
            <button
              className="hub-return"
              onClick={() => navigate('/hub')}
              title="Back to the Commercial Hub"
            >
              ← Commercial Hub
            </button>
          )}

          {isStaff ? (
            <>
              <div className="role-switch">
                <button className={role === 'agent' ? 'on' : ''} onClick={() => { setRole('agent'); navigate('/'); }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round">
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 21v-1a7 7 0 0 1 14 0v1" />
                  </svg>
                  Agent
                </button>
                <button className={role === 'aas' ? 'on' : ''} onClick={() => { setRole('aas'); navigate('/'); }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M15 9h.01M9 13h.01M15 13h.01" />
                  </svg>
                  AAS Specialist
                </button>
              </div>
              <button
                className="reset-link"
                style={{ marginLeft: 16, color: '#fff' }}
                onClick={() => void signOut()}
                title={email ?? undefined}
              >
                <LogoutIcon width={15} height={15} /> Sign out
              </button>
            </>
          ) : email ? (
            /**
             * Signed in, but not staff — a hub member.
             *
             * ⚠️ THIS BRANCH EXISTS BECAUSE ITS ABSENCE COST AN HOUR (2026-08-30).
             * A signed-in member used to see "AAS staff sign in" here, identical
             * to being signed out: no name, no way out, and an inviting button
             * that leads to Microsoft and rejects them with AADSTS90072 because
             * they are not in the AAS tenant. Members authenticate by emailed
             * link, never through Entra. Showing them who they are, and a way to
             * leave, is the whole fix.
             */
            <>
              <span style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.85)' }}>{email}</span>
              <button className="reset-link" style={{ marginLeft: 14, color: '#fff' }} onClick={() => void signOut()}>
                <LogoutIcon width={15} height={15} /> Sign out
              </button>
            </>
          ) : (
            // Muted on purpose: this is for internal staff only. Agents kept mistaking
            // it for "how I log in to submit" and hitting the Microsoft sign-in dead-end.
            <button
              className="reset-link"
              style={{ color: 'rgba(255,255,255,0.55)', fontSize: 12, fontWeight: 500 }}
              onClick={() => void signIn()}
              title="Agents Alliance staff only"
            >
              <LoginIcon width={13} height={13} /> AAS staff sign in
            </button>
          )}
        </div>
      </div>
    </>
  );
}
